<template>
<div class="editor_viewport_wrap" ref="editor_viewport_wrap">
<div class="editor_viewport animate_class" :style="'width:'+editor_viewport_width">

<div class="grid">



</div>

</div>
</div>
</template>

<script>
export default {

  name: 'CustomScoreDisplay',
  props:["view_mode","theschema"],
  data () {
    return {
    	
    }
  },
  computed:{
  	editor_viewport_width()
  	{
  		if(this.view_mode=="desktop")
  		{
  			return "100%"
  		}
  		if(this.view_mode=="mobile")
  		{
  			return "390px"
  		}
  	},
  },
  methods:{
  }
}
</script>

<style lang="css" scoped>

.editor_viewport_wrap{
	width: 100%;
	min-height: 100px;
	padding: 12px;
	display: flex;
	justify-content: center;
}
.editor_viewport{
	border-radius: 8px;
	background-color: #fff;
	min-height: 100px;
	box-shadow: rgb(93 62 188 / 10%) 0px 6px 24px;
}
</style>